function showHideLinks() {
  const linkContainer = document.querySelector('.product__section-link');
  const productLook = document.getElementById('productLook');
  if (productLook) {
    if (window.innerWidth < 990) {
      if (window.scrollY < productLook.offsetTop) {
        if (!linkContainer.classList.contains("top-position")) linkContainer.classList.add("top-position");
      } else {
        if (linkContainer.classList.contains("top-position")) linkContainer.classList.remove("top-position");
      }
    }
  }
}

function debounce(func) {
  let rafId;

  return function () {
    if (rafId) return;
    rafId = window.requestAnimationFrame(() => {
      func.apply(this, arguments);
      rafId = null;
    });
  };
}

document.addEventListener('DOMContentLoaded', showHideLinks);
window.addEventListener('resize', debounce(showHideLinks));
window.addEventListener('scroll', debounce(showHideLinks));